export default {"src":"/nachrichten/_next/static/media/error-light.9c38291b.svg","height":150,"width":116,"blurWidth":0,"blurHeight":0};